// Omnix/client/mainLayout.js


export default {
    defaultRoute: '/entry/login',
    defaultRoutes: {
        public: '/entry/login',
        user: '/user/dashboard',
        manager: '/manager/dashboard',
        admin: '/admin/dashboard',
        login: '/entry/login',
        entry: '/entry',
    },

    layers: {
        "base": {
            template: `<div id="root-container-wrapper" class="vh-100"><div id="dev-tools-container"></div></div>`,
            container: 'root-container',
            components: [
                { name: 'entry', type: 'layer', layer: 'entry', container: 'root-container-wrapper' },
                { name: 'app', type: 'layer', layer: 'app', container: 'root-container-wrapper' },
                { name: 'error', type: 'layer', layer: 'error', container: 'root-container-wrapper' },
                { name: 'devtools', type: 'DevTools', container: 'dev-tools-container' },
                { name: 'payment-gateway', type: 'PaymentGatewayComponent', container: 'root-container-wrapper' },

            ]
        },
        entry: {
            route: '/entry',
            template: `
                <div class="ab-entry-page">
                    <div id="entry-titlebar-controls" class="electron-only-titlebar-host justify-content-end" style="position: absolute; top: 0; right: 0; height: 48px; app-region: no-drag; -webkit-app-region: no-drag; user-select: none; z-index: 9999;">
                        <div id="entry-titlebar-controls-target" class="h-100" style="app-region: no-drag; -webkit-app-region: no-drag;"></div>
                    </div>
                    <div class="ab-entry-branding">
                        <div id="entry-branding-logo" class="mb-4"></div>
                        <h1 class="ab-entry-headline" data-i18n="All Your Conversations, One Place">All Your Conversations, One Place</h1>
                        <p class="ab-entry-subline" data-i18n="Log in to your OmniChannel workspace to connect with customers, manage tickets, and automate your communications.">Log in to your OmniChannel workspace to connect with customers, manage tickets, and automate your communications.</p>
                        <ul class="ab-entry-features">
                            <li><i class="bi bi-inboxes-fill"></i><div><strong data-i18n="Unified Inbox:">Unified Inbox:</strong> <span data-i18n="Engage across SMS, Voice, WhatsApp, and more.">Engage across SMS, Voice, WhatsApp, and more.</span></div></li>
                            <li><i class="bi bi-robot"></i><div><strong data-i18n="AI-Powered Agents:">AI-Powered Agents:</strong> <span data-i18n="Automate responses and assist your human team 24/7.">Automate responses and assist your human team 24/7.</span></div></li>
                            <li><i class="bi bi-bar-chart-line-fill"></i><div><strong data-i18n="Actionable Analytics:">Actionable Analytics:</strong> <span data-i18n="Gain insights into team performance and customer satisfaction.">Gain insights into team performance and customer satisfaction.</span></div></li>
                        </ul>
                    </div>
                    <div class="ab-entry-card-container">
                        <div class="ab-entry-card">
                            <div id="entry-mobile-logo" class="ab-entry-mobile-logo"></div>
                            <div id="entry-component-target"></div>
                            <div class="ab-entry-card-footer">
                                <a href="/entry/login" data-i18n="Login">Login</a>
                                <span>·</span>
                                <a href="/entry/signup" data-i18n="Sign Up">Sign Up</a>
                                <span>·</span>
                                <a href="/entry/forgot-password" data-i18n="Forgot Password">Forgot Password</a>
                            </div>
                        </div>
                    </div>
                    <div class="ab-entry-terms">
                        By continuing, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>.
                    </div>
                </div>
            `,
            components: [
                { name: 'branding-logo', type: 'LogoComponent', container: 'entry-branding-logo', props: { logoText: 'Omnix', iconClass: 'bi-chat-quote-fill' } },
                { name: 'mobile-logo', type: 'LogoComponent', container: 'entry-mobile-logo', props: { logoText: 'Omnix', iconClass: 'bi-chat-quote-fill' } },
                { name: 'titlebar-controls-entry', type: 'TitleBarControls', container: 'entry-titlebar-controls-target' },
                { name: 'login-layer', type: 'layer', layer: 'login', container: 'entry-component-target', default: true },
                { name: 'signup-layer', type: 'layer', layer: 'signup', container: 'entry-component-target' },
                { name: 'forgotpassword-layer', type: 'layer', layer: 'forgotpassword', container: 'entry-component-target' }
            ]
        }, login: { route: '/entry/login', template: `<div id="login-form-target"></div>`, components: [{ type: 'Login', container: 'login-form-target' }] },
        signup: { route: '/entry/signup', template: `<div id="signup-form-target"></div>`, components: [{ type: 'Signup', container: 'signup-form-target' }] },
        forgotpassword: { route: '/entry/forgot-password', template: `<div id="forgotpassword-form-target"></div>`, components: [{ type: 'ForgotPassword', container: 'forgotpassword-form-target' }] },

        "common-header": {
            template: `
                <div class="d-flex align-items-center w-100 h-100" style="app-region: drag; -webkit-app-region: drag; user-select: none;">
                    <div class="d-flex align-items-center gap-3 h-100" style="app-region: drag; -webkit-app-region: drag;">
                        <div id="common-logo-target" class="ms-2"></div>
                    </div>
                    <div class="flex-grow-1 h-100"></div>
                    <div id="shared-header-actions" class="d-flex align-items-center h-100" style="app-region: no-drag; -webkit-app-region: no-drag;">
                        <div id="common-role-switcher-container" class="ms-2"></div>
                        <div id="common-notifications-container" class="ms-2"></div>
                        <div id="documentation-link-container" class="ms-2"></div>
                        <div id="softphone-controller-container" class="ms-2"></div>
                        <div id="common-user-profile-menu-container" class="ms-2 px-2"></div>
                        <div id="common-titlebar-controls" class="h-100"></div>
                    </div>
                </div>`,
            components: [
                {
                    name: 'common-logo', type: 'LogoComponent', container: 'common-logo-target',
                    props: {
                        desktopLogoUrl: '/public/logo.png',
                        mobileLogoUrl: '/public/android-chrome-192x192.png',
                        desktopImageHeight: '35px'
                    }
                },
                { name: 'common-role-switcher', type: 'RoleSwitcher', container: 'common-role-switcher-container', props: { switchableRoles: ['user', 'manager', 'admin'], roleIcons: { user: 'bi-headset', manager: 'bi-kanban-fill', admin: 'bi-shield-lock-fill' } } },
                { name: 'notifications-menu', type: 'Notifications', container: 'common-notifications-container' },
                { name: 'documentation-link', type: 'DocumentationLink', container: 'documentation-link-container' },
                { name: 'softphone-controller', type: 'SoftphoneController', container: 'softphone-controller-container', instanceId: 'main-softphone-controller' },
                { name: 'handoff-controller', type: 'HandoffController', container: 'shared-header-actions', instanceId: 'main-handoff-controller' }, // NEW
                { name: 'common-user-menu', type: 'UserProfileMenu', container: 'common-user-profile-menu-container', props: { menuItems: [{ title: "Profile", route: "/user/profile" }] } },
                { name: 'titlebar-controls', type: 'TitleBarControls', container: 'common-titlebar-controls' }
            ]
        },

        app: {
            route: '/app',
            template: `
                <div id="app-wrapper" class="d-flex flex-column h-100">
                    <header id="shared-header-area" class="app-header border-bottom"></header>
                    <div id="app-body-area" class="flex-grow-1 overflow-hidden"></div>
                    <div id="app-level-widgets-container"></div>

                </div>`,
            components: [
                { name: 'common-header-layer', type: 'layer', layer: 'common-header', container: 'shared-header-area' },
                { name: 'user-layer', type: 'layer', layer: 'user', container: 'app-body-area' },
                { name: 'manager-layer', type: 'layer', layer: 'manager', container: 'app-body-area' },
                { name: 'admin-layer', type: 'layer', layer: 'admin', container: 'app-body-area' },
                { name: 'omnix-assistant', type: 'OmnixAssistantWidget', container: 'app-level-widgets-container', instanceId: 'mainOmnixAssistant' }

            ]
        },

        user: {
            route: '/user',
            template: `
                <div class="d-flex flex-row h-100">
                    <aside id="user-sidebar-target" class="app-sidebar border-end"></aside>
                    <main id="user-content-target" class="flex-grow-1 overflow-auto p-1"></main>
                </div>`,
            components: [
                { name: 'user-menu', type: 'AppMenu', container: 'user-sidebar-target', instanceId: 'user-menu', props: { startingRoute: '/user/', fullHeight: true, collapsible: true, defaultCollapsed: true, saveState: true } },
                { name: 'user-content-switch', type: 'layer', layer: 'user-content', container: 'user-content-target', default: true },
            ]
        },
        'user-content': {
            template: `<div id="user-feature-area" class="h-100"></div>`,
            components: [
                { name: 'user-dashboard-layer', type: 'layer', layer: 'user-dashboard-layer', container: 'user-feature-area', default: true },
                { name: 'user-inbox-layer', type: 'layer', layer: 'user-inbox-layer', container: 'user-feature-area' },
                { name: 'user-contacts-layer', type: 'layer', layer: 'user-contacts-layer', container: 'user-feature-area' },
                { name: 'user-tickets-layer', type: 'layer', layer: 'user-tickets-layer', container: 'user-feature-area' },
                { name: 'user-profile-layer', type: 'layer', layer: 'user-profile-layer', container: 'user-feature-area' },
            ]
        },
        'user-dashboard-layer': { route: '/user/dashboard', menuItem: true, menuTitle: 'Dashboard', menuIcon: 'bi-house-door', template: `<div id="user-dashboard-target" class="h-100"></div>`, components: [{ type: 'Dashboard', container: 'user-dashboard-target', instanceId: 'userDashboard', props: { role: 'user' } }] },
        'user-inbox-layer': {
            route: '/user/inbox',
            menuItem: true,
            menuTitle: 'Inbox',
            menuIcon: 'bi-inbox-fill',
            template: `<div id="user-inbox-target" class="h-100"></div>`,
            components: [{ type: 'UnifiedInbox', container: 'user-inbox-target', instanceId: 'mainInbox' }]
        },

        'user-contacts-layer': { route: '/user/contacts', menuItem: true, menuTitle: 'Contacts', menuIcon: 'bi-people-fill', template: `<div id="user-contacts-target" class="h-100"></div>`, components: [{ type: 'ContactManager', container: 'user-contacts-target' }] },

        'user-tickets-layer': {
            route: '/user/tickets',
            menuTitle: 'Tickets',
            menuIcon: 'bi-ticket-perforated-fill',
            template: `<div id="user-tickets-target" class="h-100"></div>`,
            components: [{
                type: 'TicketManager',
                container: 'user-tickets-target',
                instanceId: 'mainTicketManager'
            }]
        },
        'user-profile-layer': { route: '/user/profile', hideInMenu: true, template: `<div id="user-profile-target" class="h-100"></div>`, components: [{ type: 'UserProfile', container: 'user-profile-target' }] },

        manager: {
            route: '/manager',
            template: `
                <div class="d-flex flex-row h-100">
                    <aside id="manager-sidebar-target" class="app-sidebar border-end"></aside>
                    <main id="manager-content-target" class="flex-grow-1 overflow-auto p-1"></main>
                </div>`,
            components: [
                { name: 'manager-menu', type: 'AppMenu', container: 'manager-sidebar-target', instanceId: 'manager-menu', props: { startingRoute: '/manager/', fullHeight: true, collapsible: true, defaultCollapsed: true, saveState: true } },
                { name: 'manager-content-switch', type: 'layer', layer: 'manager-content', container: 'manager-content-target', default: true },
            ]
        },
        'manager-content': {
            template: `<div id="manager-feature-area" class="h-100"></div>`,
            components: [
                { name: 'manager-dashboard-layer', type: 'layer', layer: 'manager-dashboard-layer', container: 'manager-feature-area', default: true },
                { name: 'manager-templates-layer', type: 'layer', layer: 'manager-templates-layer', container: 'manager-feature-area' },
                { name: 'manager-audiences-layer', type: 'layer', layer: 'manager-audiences-layer', container: 'manager-feature-area' }, // NEW
                { name: 'manager-campaigns-layer', type: 'layer', layer: 'manager-campaigns-layer', container: 'manager-feature-area' },
            ]
        },
        'manager-dashboard-layer': { route: '/manager/dashboard', menuItem: true, menuTitle: 'Dashboard', menuIcon: 'bi-kanban-fill', template: `<div id="manager-dashboard-target" class="h-100"></div>`, components: [{ type: 'Dashboard', container: 'manager-dashboard-target', instanceId: 'managerDashboard', props: { role: 'manager' } }] },

        'manager-templates-layer': {
            route: '/manager/templates',
            menuItem: true,
            menuTitle: 'Templates',
            menuIcon: 'bi-journal-richtext',
            template: `<div id="manager-templates-target" class="h-100"></div>`,
            components: [{ type: 'TemplateManager', container: 'manager-templates-target', instanceId: 'mainTemplateManager' }]
        },

        'manager-audiences-layer': {
            route: '/manager/audiences',
            menuItem: true,
            menuTitle: 'Audiences',
            menuIcon: 'bi-people-fill',
            template: `<div id="manager-audiences-target" class="h-100"></div>`,
            components: [{ type: 'AudienceManager', container: 'manager-audiences-target', instanceId: 'mainAudienceManager' }]
        },

        'manager-campaigns-layer': {
            route: '/manager/campaigns',
            menuItem: true,
            menuTitle: 'Campaigns',
            menuIcon: 'bi-megaphone-fill',
            template: `<div id="manager-campaigns-target" class="h-100"></div>`,
            components: [{ type: 'CampaignManager', container: 'manager-campaigns-target', instanceId: 'mainCampaignManager' }]
        },

        admin: {
            route: '/admin',
            template: `
                <div class="d-flex flex-row h-100">
                    <aside id="admin-sidebar-target" class="app-sidebar border-end"></aside>
                    <main id="admin-content-target" class="flex-grow-1 overflow-auto p-1"></main>
                </div>`,
            components: [
                { name: 'admin-menu', type: 'AppMenu', container: 'admin-sidebar-target', instanceId: 'admin-menu', props: { startingRoute: '/admin/', fullHeight: true, collapsible: true, defaultCollapsed: true, saveState: true } },
                { name: 'admin-content-switch', type: 'layer', layer: 'admin-content', container: 'admin-content-target', default: true },
            ]
        },
        'admin-content': {
            template: `<div id="admin-feature-area" class="h-100"></div>`,
            components: [
                { name: 'admin-dashboard-layer', type: 'layer', layer: 'admin-dashboard-layer', container: 'admin-feature-area', default: true },
                { name: 'admin-users-layer', type: 'layer', layer: 'admin-users-layer', container: 'admin-feature-area' },
                { name: 'admin-user-config-layer', type: 'layer', layer: 'admin-user-config', container: 'admin-feature-area' },
                { name: 'admin-channels-layer', type: 'layer', layer: 'admin-channels-layer', container: 'admin-feature-area' },
                { name: 'admin-extensions-layer', type: 'layer', layer: 'admin-extensions-layer', container: 'admin-feature-area' },
                { name: 'admin-phonenumbers-layer', type: 'layer', layer: 'admin-phonenumbers-layer', container: 'admin-feature-area' },
                { name: 'admin-audiofiles-layer', type: 'layer', layer: 'admin-audiofiles-layer', container: 'admin-feature-area' },
                { name: 'admin-agents-layer', type: 'layer', layer: 'admin-agents-layer', container: 'admin-feature-area' },
                { name: 'user-agent-config-layer', type: 'layer', layer: 'admin-agent-config-layer', container: 'admin-feature-area' },
                { name: 'admin-skills-layer', type: 'layer', layer: 'admin-skills-layer', container: 'admin-feature-area' },
                { name: 'admin-skill-config-layer', type: 'layer', layer: 'admin-skill-config-layer', container: 'admin-feature-area' },


                { name: 'admin-whatsapp-templates-layer', type: 'layer', layer: 'admin-whatsapp-templates-layer', container: 'admin-feature-area' },
                { name: 'admin-workflows-layer', type: 'layer', layer: 'admin-workflows-layer', container: 'admin-feature-area' },
                { name: 'admin-apikeys-layer', type: 'layer', layer: 'admin-apikeys-layer', container: 'admin-feature-area' },
                { name: 'admin-branding-layer', type: 'layer', layer: 'admin-branding-layer', container: 'admin-feature-area' },
                { name: 'admin-billing-layer', type: 'layer', layer: 'admin-billing', container: 'admin-feature-area' },

            ]
        },
        'admin-dashboard-layer': { route: '/admin/dashboard', menuItem: true, menuTitle: 'Admin Dashboard', menuIcon: 'bi-speedometer2', template: `<div id="admin-dashboard-target" class="h-100"></div>`, components: [{ type: 'Dashboard', container: 'admin-dashboard-target', instanceId: 'adminDashboard', props: { role: 'admin' } }] },
        'admin-users-layer': { route: '/admin/users', menuItem: true, menuTitle: 'Manage Users', menuIcon: 'bi-people-fill', template: `<div id="admin-users-target" class="h-100"></div>`, components: [{ type: 'UserManager', container: 'admin-users-target' }] },
        "admin-user-config": {
            route: '/admin/user-config', hideInMenu: true,
            template: `<div id="admin-user-config-view" class="h-100"></div>`,
            components: [
                { name: 'admin-user-config-main', type: 'UserConfigurationView', container: 'admin-user-config-view' }
            ]
        },
        'admin-channels-layer': {
            route: '/admin/channels',
            menuItem: true,
            menuTitle: 'Channels',
            menuIcon: 'bi-hdd-stack-fill',
            template: `<div id="admin-channels-target" class="h-100"></div>`,
            components: [{ type: 'ChannelManager', container: 'admin-channels-target', instanceId: 'mainChannelManager' }]
        },


        'admin-extensions-layer': {
            route: '/admin/extensions',
            menuItem: true,
            menuTitle: 'PBX Extensions',
            menuIcon: 'bi-telephone-outbound-fill',
            template: `<div id="admin-extensions-target" class="h-100"></div>`,
            components: [{ type: 'ExtensionManager', container: 'admin-extensions-target', instanceId: 'mainExtensionManager' }]
        },
        'admin-phonenumbers-layer': {
            route: '/admin/phonenumbers',
            menuItem: true,
            menuTitle: 'Phone Numbers',
            menuIcon: 'bi-hash',
            template: `<div id="admin-phonenumbers-target" class="h-100"></div>`,
            components: [{ type: 'PhoneNumberManager', container: 'admin-phonenumbers-target', instanceId: 'mainPhoneNumberManager' }]
        },
        'admin-agents-layer': {
            route: '/admin/agents',
            menuItem: true,
            menuTitle: 'AI Agents',
            menuIcon: 'bi-robot',
            template: `<div id="admin-agents-target" class="h-100"></div>`,
            components: [{ type: 'AgentManagerCrud', container: 'admin-agents-target', instanceId: 'mainAgentManager' }]
        },

        'admin-skills-layer': {
            route: '/admin/skills',
            menuItem: true,
            menuTitle: 'Skills',
            menuIcon: 'bi-gear',
            template: `<div id="admin-skills-target" class="h-100"></div>`,
            components: [{ type: 'SkillManagerCrud', container: 'admin-skills-target', instanceId: 'mainSkillManager' }]
        },


        'admin-audiofiles-layer': {
            route: '/admin/audiofiles',
            menuItem: true,
            menuTitle: 'Audio Files',
            menuIcon: 'bi-file-earmark-music-fill',
            template: `<div id="admin-audiofiles-target" class="h-100"></div>`,
            components: [{ type: 'AudioFileManager', container: 'admin-audiofiles-target', instanceId: 'mainAudioFileManager' }]
        },

        'admin-agent-config-layer': {
            route: '/admin/agent-config',
            hideInMenu: true, // Not directly in menu, accessed from agent list
            template: '<div id="admin-agent-config-content" class="h-100"></div>',
            components: [{
                name: 'admin-agent-config-view',
                type: 'AgentConfigurationView',
                container: 'admin-agent-config-content',
                instanceId: 'agentConfigView', // Give it a unique instance ID
                props: {
                    agentListRoute: '/admin/agents'
                }
            }]
        },

        'admin-skill-config-layer': {
            route: '/admin/skill-config',
            hideInMenu: true, // Not directly in menu, accessed from agent list
            template: '<div id="admin-skill-config-content" class="h-100"></div>',
            components: [{
                name: 'admin-skill-config-view',
                type: 'SkillConfigurationView',
                container: 'admin-skill-config-content',
                instanceId: 'skillConfigView', // Give it a unique instance ID
                props: {
                    agentListRoute: '/admin/skills'
                }
            }]
        },

        'admin-whatsapp-templates-layer': {
            route: '/admin/whatsapp-templates',
            menuItem: true,
            menuTitle: 'WhatsApp Templates',
            menuIcon: 'bi-whatsapp',
            template: `<div id="admin-whatsapp-templates-target" class="h-100"></div>`,
            components: [{ type: 'WhatsAppTemplateManager', container: 'admin-whatsapp-templates-target', instanceId: 'mainWaTemplateManager' }]
        },


        'admin-workflows-layer': {
            route: '/admin/workflows',
            menuItem: true,
            menuTitle: 'Workflows',
            menuIcon: 'bi-diagram-3-fill',
            template: `<div id="admin-workflows-target" class="h-100"></div>`,
            components: [{ type: 'WorkflowCrud', container: 'admin-workflows-target', instanceId: 'mainWorkflowManager' }]
        },

        'admin-apikeys-layer': {
            route: '/admin/api-keys',
            menuItem: true,
            menuTitle: 'API Keys',
            menuIcon: 'bi-key-fill',
            template: `<div id="admin-apikeys-target" class="h-100"></div>`,
            components: [{ type: 'ApiKeyManager', container: 'admin-apikeys-target', instanceId: 'mainApiKeyManager' }]
        },

        'admin-branding-layer': {
            route: '/admin/branding',
            menuItem: true,
            menuTitle: 'Branding',
            menuIcon: 'bi-palette-fill',
            template: `<div id="admin-branding-target" class="h-100"></div>`,
            components: [{ type: 'BrandingKitManager', container: 'admin-branding-target', instanceId: 'mainBrandingManager' }]
        },


        "admin-billing": {
            route: '/admin/billing',
            menuItem: true, menuTitle: 'Billing', menuIcon: 'bi-credit-card-2-front-fill', menuOrder: 8,
            template: `<div id="admin-billing-component-container" class="h-100"></div>`,
            components: [
                { name: 'admin-billing-view', type: 'BillingView', container: 'admin-billing-component-container' }
            ]
        },



    }
};
